/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompts_EmptyInputs */



/**
* | output |
* | --- |
* | "Save prompts you use often to reuse them in any project." |
*
* @param {Assistant_Saved_Prompts_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompts_empty = /** @type {((inputs?: Assistant_Saved_Prompts_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompts_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrez les invites que vous utilisez souvent pour les réutiliser dans n'importe quel projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern Sie häufig genutzte Eingabeaufforderungen, um sie in jedem Projekt wiederzuverwenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva i prompt che usi spesso per riutilizzarli in qualsiasi progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраняйте часто используемые запросы, чтобы применять их в любом проекте.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guarda las solicitudes que usas a menudo para reutilizarlas en cualquier proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存常用提示，以便在任何项目中重复使用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("よく使うプロンプトを保存すると、どのプロジェクトでも再利用できます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जिन प्रॉम्प्ट का आप अक्सर उपयोग करते हैं, उन्हें सहेजें और किसी भी प्रोजेक्ट में दोबारा उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guarde os prompts que usa com frequência para os reutilizar em qualquer projeto.")
	return /** @type {LocalizedString} */ ("Save prompts you use often to reuse them in any project.")
});